//uncomment when in production
// const SERVER_URL = "https://fmhy-server-production-791b.up.railway.app";
const SERVER_URL = "https://api.fmhy.cf";

//uncomment when in local
// const SERVER_URL = 'localhost';
module.exports = SERVER_URL;
